// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
//  VYLAPP SHARED COMPONENTS
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

export function VylappLogo({ size = 32, showText = false, textSize = 18 }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: showText ? 10 : 0 }}>
      <svg width={size} height={size} viewBox="0 0 40 40" fill="none">
        <defs>
          <linearGradient id="vg1" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%"   stopColor="#7C3AED" />
            <stop offset="100%" stopColor="#10F5A0" />
          </linearGradient>
          <linearGradient id="vg2" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%"   stopColor="#10F5A0" />
            <stop offset="100%" stopColor="#7C3AED" />
          </linearGradient>
        </defs>
        <rect width="40" height="40" rx="12" fill="url(#vg1)" opacity="0.15" />
        <rect width="40" height="40" rx="12" fill="none" stroke="url(#vg1)" strokeWidth="1.5" opacity="0.45" />
        <path d="M10 11L20 29L30 11" stroke="url(#vg1)" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        <circle cx="20" cy="29" r="3" fill="url(#vg2)" />
        <line x1="33" y1="9"  x2="36" y2="7"  stroke="#10F5A0" strokeWidth="1.5" strokeLinecap="round" opacity="0.7" />
        <line x1="35" y1="13" x2="38" y2="13" stroke="#10F5A0" strokeWidth="1.5" strokeLinecap="round" opacity="0.5" />
        <line x1="33" y1="17" x2="36" y2="19" stroke="#7C3AED" strokeWidth="1.5" strokeLinecap="round" opacity="0.4" />
      </svg>
      {showText && (
        <div>
          <div style={{
            fontFamily: "'Sora', system-ui", fontWeight: 900, fontSize: textSize,
            background: "linear-gradient(135deg,#7C3AED,#10F5A0)",
            WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
            letterSpacing: "-0.5px", lineHeight: 1,
          }}>VYLAPP</div>
          {textSize >= 14 && (
            <div style={{ color: "#7C7A9E", fontSize: 9, fontFamily: "'Space Mono',monospace", letterSpacing: 1.5, marginTop: 1 }}>
              VIBE · LEARN · CONNECT
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export function Avatar({ user, size = 40, ring = false, showOnline = false }) {
  const u = user || { initials: "?", color: "#7C3AED", online: false };
  const src = u.avatar || u.avatarUrl;
  return (
    <div style={{ position: "relative", width: size, height: size, flexShrink: 0 }}>
      {src ? (
        <img src={src} alt={u.displayName || u.initials} style={{
          width: size, height: size, borderRadius: "50%", objectFit: "cover",
          border: ring ? `2px solid ${u.color}` : `1.5px solid ${u.color}35`,
          boxShadow: ring ? `0 0 12px ${u.color}30` : "none",
        }} />
      ) : (
        <div style={{
          width: size, height: size, borderRadius: "50%",
          background: `${u.color}18`,
          border: ring ? `2px solid ${u.color}` : `1.5px solid ${u.color}35`,
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: size * 0.3, fontWeight: 700, color: u.color,
          fontFamily: "'Space Mono',monospace", letterSpacing: "-0.5px",
          boxShadow: ring ? `0 0 12px ${u.color}30` : "none",
        }}>{(u.initials || u.displayName?.[0] || "?").slice(0, 2)}</div>
      )}
      {showOnline && u.online && (
        <div style={{
          position: "absolute", bottom: 0, right: 0,
          width: size * 0.27, height: size * 0.27, borderRadius: "50%",
          background: "#10F5A0", border: `2px solid #08070F`,
          boxShadow: "0 0 6px rgba(16,245,160,0.6)",
        }} />
      )}
    </div>
  );
}

export function LiveBadge({ pulse = true }) {
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 5,
      padding: "2px 8px", borderRadius: 4, fontSize: 11, fontWeight: 700,
      color: "#FF6B6B", background: "rgba(255,107,107,0.15)",
      border: "1px solid rgba(255,107,107,0.3)", letterSpacing: 0.8,
      fontFamily: "'Space Mono',monospace",
    }}>
      <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#FF6B6B", display: "inline-block", animation: pulse ? "pulse-dot 1.5s ease-in-out infinite" : "none" }} />
      LIVE
    </span>
  );
}

export function VybePill({ label, color }) {
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 4, padding: "2px 9px",
      borderRadius: 6, fontSize: 11, fontWeight: 700, letterSpacing: 0.8,
      background: `${color}12`, color, border: `1px solid ${color}25`,
      fontFamily: "'Space Mono',monospace",
    }}>{label}</span>
  );
}

export function IconBtn({ d, s = 18, onClick, title, color = "#7C7A9E", hoverColor = "#F0EFFE" }) {
  return (
    <button onClick={onClick} title={title} style={{
      width: 36, height: 36, borderRadius: "50%", border: "none", background: "none",
      cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
      transition: "all 0.15s", flexShrink: 0,
    }}
      onMouseEnter={e => { e.currentTarget.style.background = "rgba(124,58,237,0.12)"; e.currentTarget.querySelector("svg").style.stroke = hoverColor; }}
      onMouseLeave={e => { e.currentTarget.style.background = "none"; e.currentTarget.querySelector("svg").style.stroke = color; }}>
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" style={{ transition:"stroke 0.15s", flexShrink:0 }}>
        <path d={d} />
      </svg>
    </button>
  );
}

export function Ic({ d, s = 18, c = "currentColor", f = "none", sw = 1.75 }) {
  return (
    <svg width={s} height={s} viewBox="0 0 24 24" fill={f} stroke={c} strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
      <path d={d} />
    </svg>
  );
}

export function TranslateToggle({ on, onToggle, lang, onLang }) {
  const LANGS = ["Spanish","French","Arabic","Mandarin","Portuguese","Swahili","Hindi","Japanese","Japanese","Russian"];
  return (
    <div style={{
      display: "flex", alignItems: "center", gap: 6, padding: "5px 12px",
      borderRadius: 9999, border: `1px solid ${on ? "rgba(124,58,237,0.3)" : "rgba(124,58,237,0.15)"}`,
      background: on ? "rgba(124,58,237,0.15)" : "none", cursor: "pointer", transition: "all 0.2s",
    }} onClick={onToggle}>
      <svg width={14} height={14} viewBox="0 0 24 24" fill="none" stroke={on ? "#8B5CF6" : "#7C7A9E"} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
        <path d="M5 8l6 6M4 14l6-6 2-3M2 5h12M7 2h1M22 22l-5-10-5 10M14 18h6" />
      </svg>
      <span style={{ color: on ? "#8B5CF6" : "#7C7A9E", fontSize: 13 }}>{on ? lang : "Translate"}</span>
      {on && (
        <select value={lang} onChange={e => { e.stopPropagation(); onLang(e.target.value); }}
          onClick={e => e.stopPropagation()}
          style={{ background: "transparent", border: "none", color: "#8B5CF6", fontSize: 12, cursor: "pointer" }}>
          {LANGS.map(l => <option key={l} value={l} style={{ background: "#131124" }}>{l}</option>)}
        </select>
      )}
    </div>
  );
}

export const ICONS = {
  feed:      "M13 2L3 14h9l-1 8 10-12h-9l1-8z",
  explore:   "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z",
  spaces:    "M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 11a4 4 0 100-8 4 4 0 000 8zM23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75",
  chat:      "M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z",
  bell:      "M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 01-3.46 0",
  user:      "M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2M12 11a4 4 0 100-8 4 4 0 000 8z",
  phone:     "M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 8.81 19.79 19.79 0 010 .18A2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z",
  phoneOff:  "M10.68 13.31a16 16 0 003.41 2.6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7 2 2 0 011.72 2v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.45 19.45 0 01-3.41-2.68M6.51 6.51A19.5 19.5 0 003.07 8.81 19.79 19.79 0 000 17.44A2 2 0 002 19.5h3a2 2 0 002-1.72c.127-.96.361-1.903.7-2.81a2 2 0 00-.45-2.11L6.09 11.6M23 1L1 23",
  video:     "M23 7l-7 5 7 5V7zM1 5h15a2 2 0 012 2v10a2 2 0 01-2 2H1a2 2 0 01-2-2V7a2 2 0 012-2z",
  videoOff:  "M16 16v1a2 2 0 01-2 2H3a2 2 0 01-2-2V7a2 2 0 012-2h2m5.66 0H14a2 2 0 012 2v3.34l1 1L23 7v10M1 1l22 22",
  mic:       "M12 1a3 3 0 00-3 3v8a3 3 0 006 0V4a3 3 0 00-3-3zM19 10v2a7 7 0 01-14 0v-2M12 19v4M8 23h8",
  micOff:    "M1 1l22 22M9 9v3a3 3 0 005.12 2.12M15 9.34V4a3 3 0 00-5.94-.6M17 16.95A7 7 0 015 12v-2m14 0v2a7 7 0 01-.11 1.23M12 19v4M8 23h8",
  screen:    "M13 3H4a2 2 0 00-2 2v10a2 2 0 002 2h16a2 2 0 002-2v-3M8 21h8M12 17v4M17 1l4 4-4 4M21 5H9",
  record:    "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
  download:  "M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3",
  stream:    "M5 12.55a11 11 0 0114.08 0M1.42 9a16 16 0 0121.16 0M8.53 16.11a6 16 0 016.95 0M12 20h.01",
  translate: "M5 8l6 6M4 14l6-6 2-3M2 5h12M7 2h1M22 22l-5-10-5 10M14 18h6",
  heart:     "M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z",
  repeat:    "M17 1l4 4-4 4M3 11V9a4 4 0 014-4h14M7 23l-4-4 4-4M21 13v2a4 4 0 01-4 4H3",
  share:     "M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8M16 6l-4-4-4 4M12 2v13",
  comment:   "M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z",
  plus:      "M12 5v14M5 12h14",
  close:     "M18 6L6 18M6 6l12 12",
  dots:      "M12 5h.01M12 12h.01M12 19h.01",
  send:      "M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z",
  search:    "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z",
  globe:     "M12 2a10 10 0 100 20A10 10 0 0012 2zM2 12h20M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z",
  settings:  "M12 15a3 3 0 100-6 3 3 0 000 6z",
  edit:      "M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z",
  trending:  "M23 6l-9.5 9.5-5-5L1 18M17 6h6v6",
  check:     "M20 6L9 17l-5-5",
  logout:    "M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9",
};
